<template>
  <li class="node-tree">
    <div class="columns" v-if="node.label != 'Parent'">
      <div class="column">
        <b-field v-if="node.label > 1">
          <multiselect
            v-model="node.form.condition"
            :options="conditions"
            placeholder="Select"
            :searchable="true"
            :show-labels="false"
          ></multiselect>
        </b-field>
        <b-field v-else>
          <b-input
            name="condition"
            value="where"
            v-model="node.form.condition"
            disabled
            class="rule-tree-input"
          ></b-input>
        </b-field>
      </div>

      <div class="column">
        <b-field class="property">
          <!-- {{
            node.form.property &&
            node.form.property.dropdown_field &&
            !hasDropdown
              ? setValueField(node.form.property)
              : null
          }} -->
          <multiselect
            v-model="node.form.property"
            :options="activeProperties"
            placeholder="Select"
            :searchable="true"
            label="property"
            track-by="id"
            @input="setValueField"
            :max-height="150"
            :show-labels="false"
            required
          >
          </multiselect>
        </b-field>
      </div>
      <div class="column">
        <b-field>
          <multiselect
            v-model="node.form.operator"
            :options="activeOperators"
            placeholder="Select"
            :searchable="true"
            label="name"
            track-by="id"
            :max-height="150"
            :show-labels="false"
            required
          >
          </multiselect>
        </b-field>
      </div>
      <div class="column">
        <b-field v-if="hasDropdown" class="depnendentDropDown">
          <multiselect
            v-model="node.form.value"
            :options="dropDownValues"
            placeholder="Select"
            :searchable="true"
            :max-height="150"
            :show-labels="false"
            :multiple="isMultiValueOperator"
            :close-on-select="!isMultiValueOperator"
            :clear-on-select="!isMultiValueOperator"
            :preserve-search="isMultiValueOperator"
            @input="handleValueChange"
            required
          />
        </b-field>
        <b-field v-else>
          <b-input
            v-if="hasNumericInput && !isMultiValueOperator"
            name="value"
            type="number"
            min="0"
            step="0.0001"
            v-model="node.form.value"
            :value="node.form.value || ''"
            @input="value => $set(node.form, 'value', value)"
            class="rule-tree-input"
            required
          />
          <b-input
            v-else
            name="value"
            type="text"
            class="rule-tree-input"
            v-model="node.form.value"
            :value="node.form.value || ''"
            @input="value => $set(node.form, 'value', value)"
            required
          />
        </b-field>
      </div>
      <div class="column is-2 rules-right-menu-dropdown">
        <b-dropdown :triggers="['hover', 'click']" aria-role="list">
          <template #trigger>
            <a label="..." type="is-normal" href="#">...</a>
          </template>

          <b-dropdown-item
            v-if="node.label > 1"
            aria-role="listitem"
            @click="remove(node.label)"
            >Delete</b-dropdown-item
          >
          <b-dropdown-item aria-role="listitem" @click="addChild(node.label)"
            >Add Criteria</b-dropdown-item
          >
          <b-dropdown-item
            href="#"
            v-if="checkNode(node)"
            @click="moveElement(node.label, node, -1)"
            >Move Up</b-dropdown-item
          >
          <b-dropdown-item
            href="#"
            v-if="checkDownNode(node)"
            @click="moveElement(node.label, node, 1)"
            >Move Down</b-dropdown-item
          >
        </b-dropdown>
      </div>
    </div>

    <ul v-if="node.children && node.children.length">
      <node
        v-for="(child, index) in node.children"
        :node="child"
        :key="index"
        @confirm="updatedNode"
      ></node>
    </ul>
  </li>
</template>

<script>
import RulesManagerService from "../../services/RulesManagerService";
import Multiselect from "vue-multiselect";
export default {
  name: "node",
  props: {
    node: Object,
    action: String
  },
  components: { Multiselect },
  data() {
    return {
      RulesManagerService: new RulesManagerService(),
      treeNode: this.node,
      properties: this.$store.state.properties,
      operators: this.$store.state.operators,
      dropDownValues: [],
      hasDropdown: false,
      hasNumericInput: false,
      conditions: ["and", "or"]
    };
  },
  created() {
    // Initialize node form if it doesn't exist
    if (this.node && !this.node.form) {
      this.$set(this.node, "form", {});
    }

    // Initialize form fields if they don't exist
    if (this.node && this.node.form) {
      const formFields = ["condition", "property", "operator", "value"];
      formFields.forEach(field => {
        if (this.node.form[field] === undefined) {
          this.$set(this.node.form, field, null);
        }
      });

      // Process the property dropdown if it exists
      if (this.node.form.property) {
        this.processPropertyDropdown(this.node.form.property);
      }
    }
  },
  computed: {
    activeProperties() {
      return this.properties.filter(i => i.active == true);
    },
    activeOperators() {
      return this.operators.filter(i => i.active == true);
    },
    isMultiValueOperator() {
      return (
        this.node?.form?.operator?.name === "In" ||
        this.node?.form?.operator?.name === "Not In"
      );
    }
  },
  watch: {
    node(newValue) {
      this.treeNode = newValue;

      // Ensure form and value are initialized
      if (!this.treeNode.form) {
        this.$set(this.treeNode, "form", {});
      }

      if (this.treeNode.form && this.treeNode.form.value === undefined) {
        this.$set(this.treeNode.form, "value", null);
      }
    },

    "node.form.property": {
      handler(newProperty) {
        // When property changes or is updated (e.g., during rule copy),
        // re-process the dropdown detection
        if (newProperty) {
          this.processPropertyDropdown(newProperty);
        }
      },
      immediate: false
    },

    "node.form.operator": {
      handler(newOperator) {
        // When operator changes, ensure value format is correct
        if (newOperator && this.node && this.node.form) {
          const isMultiple =
            newOperator.name === "In" || newOperator.name === "Not In";
          const currentValue = this.node.form.value;

          if (isMultiple && !Array.isArray(currentValue)) {
            // Convert single value to array for multiple selection
            this.$set(
              this.node.form,
              "value",
              currentValue ? [currentValue] : []
            );
          } else if (!isMultiple && Array.isArray(currentValue)) {
            // Convert array to single value for single selection
            this.$set(
              this.node.form,
              "value",
              currentValue.length > 0 ? currentValue[0] : null
            );
          }
        }
      }
    }
  },
  methods: {
    processPropertyDropdown(property) {
      if (!property) return;

      if (property.field_type === "Dropdown") {
        this.hasDropdown = true;
        this.hasNumericInput = false;

        // Special handling for specific column types
        if (property.column_name === "chemistry") {
          this.setChemistryValues(property);
        } else if (
          property.column_name === "material_detail" ||
          property.column_name === "product_family"
        ) {
          this.processDependentDropdown(property);
        } else {
          // Standard dropdown handling
          this.dropDownValues = property.dropdown_field || [];
        }
      } else {
        // Not a dropdown
        this.hasDropdown = false;
        this.hasNumericInput = property.field_type === "Number";
        this.dropDownValues = [];
      }
    },

    // Helper method for handling nested dropdowns
    processDependentDropdown(property) {
      this.dropDownValues = [];
      // Special handling for chemistry
      if (property.column_name === "chemistry") {
        // Check if we have chemistry values in the store or as a property of the dropdown_field
        if (
          this.$store.state.chemistryDropdown &&
          this.$store.state.chemistryDropdown.length > 0
        ) {
          this.dropDownValues = this.$store.state.chemistryDropdown;
        } else if (property.dropdown_field) {
          // Try different formats that might contain chemistry values
          if (Array.isArray(property.dropdown_field)) {
            // If it's a simple array, use it directly
            this.dropDownValues = property.dropdown_field;
          } else if (typeof property.dropdown_field === "object") {
            // If it's an object with arrays as values
            const values = [];
            for (const key of Object.keys(property.dropdown_field)) {
              if (Array.isArray(property.dropdown_field[key])) {
                values.push(...property.dropdown_field[key]);
              }
            }
            this.dropDownValues = values;
          }
        }

        return;
      }

      // Handle when dropdown_field is an array with a single object (key-value mapping)
      if (
        Array.isArray(property.dropdown_field) &&
        property.dropdown_field.length === 1 &&
        typeof property.dropdown_field[0] === "object"
      ) {
        this.dropDownValues = Object.keys(property.dropdown_field[0]);
        return;
      }

      // Handle when dropdown_field is a direct object mapping
      if (
        property.dropdown_field &&
        typeof property.dropdown_field === "object"
      ) {
        const values = [];
        for (const key of Object.keys(property.dropdown_field)) {
          if (Array.isArray(property.dropdown_field[key])) {
            values.push(...property.dropdown_field[key]);
          }
        }
        this.dropDownValues = values;
      }
    },

    // Update existing method to use the new unified approach
    setValueField(selectedValue) {
      // Reset value when property changes
      // Using $set to ensure reactivity
      if (this.node && this.node.form) {
        this.$set(this.node.form, "value", null);
      }

      // Special handling for chemistry fields
      if (selectedValue && selectedValue.column_name === "chemistry") {
        this.setChemistryValues(selectedValue);
      } else {
        // Use the unified method for other field types
        this.processPropertyDropdown(selectedValue);
      }
    },

    // Special method for chemistry dropdown values
    setChemistryValues(property) {
      // Set dropdown UI state
      this.hasDropdown = true;
      this.hasNumericInput = false;

      // Initialize empty array
      this.dropDownValues = [];

      // Try to get values from property.dropdown_field first
      if (property.dropdown_field) {
        if (Array.isArray(property.dropdown_field)) {
          // Direct array - use it
          this.dropDownValues = [...property.dropdown_field];
        } else if (typeof property.dropdown_field === "object") {
          // Object with arrays - flatten them
          for (const key in property.dropdown_field) {
            if (Array.isArray(property.dropdown_field[key])) {
              this.dropDownValues = [
                ...this.dropDownValues,
                ...property.dropdown_field[key]
              ];
            }
          }
        }
      }

      // If still no values, check the store
      if (!this.dropDownValues.length) {
        if (this.$store.state.chemistry && this.$store.state.chemistry.length) {
          this.dropDownValues = this.$store.state.chemistry;
        } else if (
          this.$store.state.chemistryDropdown &&
          this.$store.state.chemistryDropdown.length
        ) {
          this.dropDownValues = this.$store.state.chemistryDropdown;
        }
      }

      // If still empty, use default values
      if (!this.dropDownValues.length) {
        this.dropDownValues = [
          "Alkaline",
          "Lead-acid",
          "Lithium-ion",
          "Lithium-metal",
          "NiCd",
          "NiMH",
          "Other"
        ];
      }
    },
    checkNode(node) {
      if (this.$store.state.treeRule && this.$store.state.treeRule.children) {
        const index = this.$store.state.treeRule.children.indexOf(node);
        if (index > 1) {
          return true;
        }
        return false;
      } else {
        return false;
      }
    },
    checkDownNode(node) {
      if (this.$store.state.treeRule && this.$store.state.treeRule.children) {
        const index = this.$store.state.treeRule.children.indexOf(node);
        const length = this.$store.state.treeRule.children.length;
        if (index < length - 1 && index > 0) {
          return true;
        }
        return false;
      } else {
        return false;
      }
    },
    moveElement(label, node, direction) {
      const index = this.$store.state.treeRule.children.indexOf(node);
      if (index > -1) {
        this.$store.state.treeRule.children.splice(
          index + direction,
          0,
          this.$store.state.treeRule.children.splice(index, 1)[0]
        );
      }
    },
    handleValueChange(value) {
      // Update the value in the node form
      this.$set(this.node.form, "value", value);

      // Handle dependent dropdown logic
      this.removeValue(this.node);
    },
    removeValue(val) {
      if (val?.form?.property?.column_name === "product_group") {
        // Reset product_family values when product_group changes
        [this.$store.state.treeRule].forEach(o => {
          o.children.forEach(m => {
            if (m?.form?.property?.column_name === "product_family") {
              // Use $set to ensure reactivity
              this.$set(m.form, "value", null);
            }
          });
        });
      }

      if (val?.form?.property?.column_name === "material_general") {
        // Reset material_detail values when material_general changes
        [this.$store.state.treeRule].forEach(o => {
          o.children.forEach(m => {
            if (m?.form?.property?.column_name === "material_detail") {
              // Use $set to ensure reactivity
              this.$set(m.form, "value", null);
            }
          });
        });
      }
    },
    // setValueField(selectedValue) {
    //   //this.action == "Add" ? (this.node.form.value = null) : "";
    //   const property = selectedValue; //this.properties.filter(e => e.id == selectedValue.id);
    //   if (property?.field_type == "Dropdown") {
    //     this.hasDropdown = true;
    //     this.dropDownValues = property.dropdown_field;
    //     if (
    //       property.column_name == "material_detail" ||
    //       property.column_name == "product_family"
    //     ) {
    //       this.dropDownValues = [];
    //       if (
    //         Array.isArray(property.dropdown_field) &&
    //         property.dropdown_field.length === 1 &&
    //         typeof property.dropdown_field[0] === "object"
    //       ) {
    //         this.dropDownValues = Object.keys(property.dropdown_field[0]);
    //       } else {
    //         for (const key of Object.keys(property.dropdown_field)) {
    //           this.dropDownValues.push(property.dropdown_field[key]);
    //           this.dropDownValues = this.dropDownValues.reduce(function(a, b) {
    //             return a.concat(b);
    //           }, []);
    //         }
    //       }
    //     }
    //   } else {
    //     this.hasDropdown = false;
    //     if (property?.field_type == "Number") {
    //       this.hasNumericInput = true;
    //     } else {
    //       this.hasNumericInput = false;
    //     }
    //   }
    // },
    updatedNode() {
      this.$emit("confirm", this.treeNode);
    },
    addChild() {
      if (this.treeNode.children == undefined) {
        this.treeNode.children = [];
      }
      this.$store.commit("incrementTreeKeyId");
      const key_id = this.$store.state.treeKeyId;
      this.treeNode.children.push({
        label: key_id,
        children: [],
        form: {}
      });
      this.$emit("confirm", this.treeNode);
    },
    remove(nodeId) {
      this.filterId([this.$store.state.treeRule], nodeId);
    },
    filterId(data, id) {
      data.forEach((o, i) => {
        if (o.label && o.label === id) {
          data.splice(i, 1);
          return true;
        } else if (o.children) {
          this.filterId(o.children, id);
        }
      });
    }
  }
};
</script>
